import {SchemeLink} from '../../../applink/SchemeLink';
import {t} from '../../../common/getTranslations';
import {requestContext} from '../../../common/requestContext';
import {twMerge} from '../../../common/twMerge';
import {showSimpleDialog} from '../../../dialog/simpleDialogHandler';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {SeparatorType} from '../../atoms/Separator/SeparatorType.enum';
import {Text} from '../../atoms/Text/Text';
import {WithSeparator} from '../../molecules/WithSeparator/WithSeparator';
import {TitleBarProps} from './TitleBarProps.type';
import {TitleBarType} from './TitleBarType.enum';

export function TitleBar({
  title,
  children,
  onClickMore,
  className,
  ...props
}: TitleBarProps) {
  return (
    <div className={twMerge('bg-theme-bg-base', className)} {...props}>
      <div
        className={twMerge(
          'flex flex-1 justify-between px-15pxr',
          props.type === TitleBarType.Main
            ? 'h-52pxr items-end pb-8pxr'
            : props.type === TitleBarType.Sub
              ? 'h-44pxr items-end pb-6pxr'
              : props.type === TitleBarType.Helix
                ? 'h-22pxr items-center'
                : 'h-48pxr items-center'
        )}
      >
        {title && (
          <div className="flex flex-1 items-center">
            <Text
              className={twMerge(
                'font-medium1-bold text-theme-solid-100 line-clamp-2',
                props.type === TitleBarType.Sub &&
                  (props.labelList && props.labelList.length > 0
                    ? 'font-medium2'
                    : 'font-medium2-bold'),
                props.type === TitleBarType.Helix && 'line-clamp-1'
              )}
            >
              {title}
            </Text>
            {props.type === TitleBarType.Helix &&
              'description' in props &&
              props.description && (
                <Icon
                  type={IconType.ButtonHelpM}
                  className="ml-4pxr"
                  onClick={() => {
                    showSimpleDialog({
                      isMobile: requestContext.requestInfo.display.isMobile,
                      title: '',
                      description: props.description || undefined,
                      okButton: {
                        text: t('common_confirm_button'),
                        type: 'label',
                        closeAfterClick: true,
                      },
                    });
                  }}
                />
              )}
          </div>
        )}

        <div
          className={twMerge(
            'shrink-0',
            props.type === TitleBarType.Helix ? 'ml-8pxr' : 'ml-12pxr'
          )}
        >
          {(props.type === TitleBarType.Main ||
            props.type === TitleBarType.Helix) &&
            'scheme' in props &&
            props.scheme && (
              <SchemeLink scheme={props.scheme}>
                <Icon
                  type={IconType.TitleBarArrowRight}
                  onClickCapture={onClickMore}
                />
              </SchemeLink>
            )}
          {props.type === TitleBarType.Landing && (
            <div
              className={twMerge(
                'flex items-center space-x-4pxr',
                props.onClickLabel && 'cursor-pointer'
              )}
              onClick={props.onClickLabel}
            >
              <Text className="font-small2 text-theme-solid-40">
                {props.label}
              </Text>
              {props.icon && <Icon type={props.icon} />}
            </div>
          )}
          {props.type === TitleBarType.Sub &&
            props.labelList &&
            props.labelList.length > 0 && (
              <WithSeparator
                separatorType={SeparatorType.Line}
                separatorClassName="h-10pxr bg-theme-solid-20 mx-16pxr"
              >
                {props.labelList.map((label, index) => (
                  <Text
                    key={index}
                    className={twMerge(
                      'font-small2 cursor-pointer text-theme-solid-60',
                      props.selectedIndex === index && 'text-theme-solid-100'
                    )}
                    onClick={() => props.onClickLabel?.(index)}
                  >
                    {label}
                  </Text>
                ))}
              </WithSeparator>
            )}
        </div>
      </div>
      {/* 타이틀바 아래에 한 세트로 붙어있는 경우 */}
      {children && <div className="pl-10pxr">{children}</div>}
    </div>
  );
}
